import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Riporta la vista in cima ad ogni cambio di route (frontend utente + VD Manager).
export const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};
